<template>
    <div class="upload-photo-wrapper" v-loading.fullscreen.lock="loading" element-loading-text="数据上传中，请不要离开当前页面">
        <div class="breadcrumb">导入照片
            <div class="header-buttons right_f">
                <el-button type="primary" @click="goToImportRecord" class="record-btn">导入记录</el-button>
                <el-button type="primary" @click="goback" class="return-btn">返回</el-button>
            </div>
        </div>

        <div class="upload-container">
            <h3>照片上传要求</h3>
            
            <p>照片保存为JPG格式，并将学生照片按照马甲号学生id命名（不可重复）。并打包压缩包，仅支持.ZIP文件上传。</p>
            <p class="warning">(ZIP包大小不超过600M,单张不能超过2M)</p>
            
            <p>上传错误时，存在类型：</p>
            <p>(1) 马甲号学生id不存在</p>
            <p>(2) 照片格式错误</p>
            <p>(3) 照片过大</p>
        </div>

        <!-- 自定义上传区域 -->
        <div class="custom-upload-area" @click="triggerFileInput" @dragover.prevent @drop.prevent="handleDrop">
            <input 
                type="file" 
                ref="fileInput" 
                style="display: none;" 
                accept=".zip" 
                @change="handleFileChange"
            >
            <i class="el-icon-upload" style="font-size: 67px; color: #c0c4cc; margin: 20px 0 16px;"></i>
            <div style="color: #606266; font-size: 14px; text-align: center; margin: 0 0 20px;">
                将文件拖到此处，或<em style="color: #409EFF; font-style: normal;">点击上传</em>
            </div>
        </div>

        <!-- 添加一个紧急关闭按钮 -->
        <div v-if="loading" class="emergency-close">
            <el-button type="danger" @click="emergencyClose">紧急关闭加载状态</el-button>
        </div>
    </div>
</template>

<script>
import { OBSuploadRedRank } from '../../../common/huaweicloud';

export default {
    data() {
        return {
            loading: false,
            isUploading: false // 添加上传状态标志
        }
    },

    methods: {
        // 返回
        goback() {
            // this.$router.push('/yunying/photo/list');
            this.$router.go(-1);
        },

        // 前往导入记录页面
        goToImportRecord() {
            this.$util.refreshTo("/#/photo/photoRecord");
        },
        
        // 触发文件输入框点击
        triggerFileInput() {
            if (!this.isUploading) {
                this.$refs.fileInput.click();
            }
        },
        
        // 处理拖放
        handleDrop(e) {
            if (this.isUploading) return;
            
            const files = e.dataTransfer.files;
            if (files.length > 0) {
                const file = files[0];
                this.validateAndUpload(file);
            }
        },
        
        // 文件变化时的处理
        handleFileChange(e) {
            if (this.isUploading) return;
            
            const files = e.target.files;
            if (files.length > 0) {
                const file = files[0];
                this.validateAndUpload(file);
            }
        },
        
        // 验证并上传文件
        validateAndUpload(file) {
            const fileExt = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
            if (fileExt !== '.zip') {
                this.$util.errorMsg('文件格式有误，请上传ZIP文件');
                this.$refs.fileInput.value = '';
                return;
            }
            
            // 检查文件大小
            if (file.size > 600 * 1024 * 1024) { // 600MB
                this.$util.errorMsg('文件大小超过600MB限制');
                this.$refs.fileInput.value = '';
                return;
            }
            
            this.uploadFile(file);
        },

        // 上传文件
        uploadFile(file) {
            console.log('开始上传文件:', file.name);
            
            this.isUploading = true;
            this.loading = true;
            
            // 添加超时处理
            const timeout = setTimeout(() => {
                this.loading = false;
                this.isUploading = false;
                this.$util.errorMsg('上传超时，请重试');
                this.$refs.fileInput.value = '';
            }, 60000); // 60秒超时
            
            // 使用红人榜照片上传方法
            try {
                console.log('调用 OBSuploadRedRank 函数');
                
                OBSuploadRedRank(file).then(res => {
                    clearTimeout(timeout); // 清除超时
                    console.log('OBSuploadRedRank 返回结果:', res);
                    
                    if (res) {
                        this.submitPhotoUrl(res);
                    } else {
                        this.$util.errorMsg('上传文件失败: 服务返回空结果');
                        this.loading = false;
                        this.isUploading = false;
                        this.$refs.fileInput.value = '';
                    }
                }).catch(err => {
                    clearTimeout(timeout); // 清除超时
                    console.error('上传错误详情:', err);
                    this.$util.errorMsg('上传文件失败: ' + (err.message || '未知错误'));
                    this.loading = false;
                    this.isUploading = false;
                    this.$refs.fileInput.value = '';
                });
            } catch (error) {
                clearTimeout(timeout); // 清除超时
                console.error('上传过程发生异常:', error);
                this.$util.errorMsg('上传过程发生错误: ' + (error.message || '未知错误'));
                this.loading = false;
                this.isUploading = false;
                this.$refs.fileInput.value = '';
            }
        },
        
        // 提交照片OBS地址
        submitPhotoUrl(url) {
            // 添加超时处理
            const timeout = setTimeout(() => {
                this.loading = false;
                this.isUploading = false;
                this.$util.errorMsg('提交地址超时，请重试');
                this.$refs.fileInput.value = '';
            }, 30000); // 30秒超时
            
            // 将文件URL作为参数拼接在请求地址后面
            const requestUrl = `${this.$util.domain}/adminapi/redRank/import?file=${encodeURIComponent(url)}`;
            
            this.$http({
                url: requestUrl,
                method: 'POST',
                body: JSON.stringify({})  // 空的请求体
            }).then(res => {
                clearTimeout(timeout); // 清除超时
                if (res.data && res.data.error == 10000) {
                    this.$util.successMsg('上传文件成功');
                } else {
                    this.$util.errorMsg((res.data && res.data.message) || '上传文件地址失败');
                }
                this.loading = false; // 确保关闭加载状态
                this.isUploading = false;
                this.$refs.fileInput.value = '';
            }).catch(err => {
                clearTimeout(timeout); // 清除超时
                console.error('提交地址错误:', err);
                this.$util.errorMsg('上传文件地址失败: ' + (err.message || '未知错误'));
                this.loading = false; // 确保关闭加载状态
                this.isUploading = false;
                this.$refs.fileInput.value = '';
            });
        },

        // 紧急关闭加载状态
        emergencyClose() {
            this.loading = false;
            this.isUploading = false;
            this.$refs.fileInput.value = '';
            this.$util.errorMsg('已手动关闭加载状态');
        }
    }
}
</script>

<style scoped>
.upload-photo-wrapper {
    padding: 0;
    background-color: #f5f7fa;
}

.breadcrumb {
    height: 50px;
    line-height: 50px;
    padding: 0 20px;
    background-color: #fff;
    font-size: 14px;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 20px;
    position: relative;
}

.right_f {
    float: right;
}

.header-buttons {
    display: flex;
    align-items: center;
}

.record-btn, .return-btn {
    margin-left: 10px;
}

.upload-container {
    background-color: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 20px;
    width: 920px;
    margin: 20px auto;
    box-sizing: border-box;
}

.upload-container h3 {
    font-size: 16px;
    margin-bottom: 15px;
    border-bottom: 1px solid #ebeef5;
    padding-bottom: 10px;
}

.upload-container p {
    line-height: 24px;
    margin: 8px 0;
}

.warning {
    color: #f56c6c;
}

/* 自定义上传区域 */
.custom-upload-area {
    width: 920px;
    height: 200px;
    margin: 20px auto;
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: border-color 0.3s;
}

.custom-upload-area:hover {
    border-color: #409EFF;
}

.emergency-close {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 9999;
}
</style> 


// WEBPACK FOOTER //
// photoImport.vue?3b613caa